export default __webpack_public_path__ + "static/media/6.b3c2806f.jpg";